export default "__VITE_ASSET__55fcc3de__"